// Send a keystroke sequence to a PTY ONE KEY AT A TIME, like a real terminal (xterm) does.
//
// Why: TUIs built on Ink/readline (Claude Code, many installers) read stdin as discrete
// keypress events. When we write a whole multi-byte sequence in ONE chunk (e.g. an arrow +
// Enter, or "digit + Enter"), the app can mis-read it as a paste / single blob and drop the
// navigation — single bytes (a bare digit) work, multi-byte blobs don't. xterm avoids this by
// emitting each keypress separately, so we mirror that: split into keys + send with a small gap.
//
// A "key" is one escape sequence (CSI `\x1b[…letter`, SS3 `\x1bO letter`, or a lone ESC) or a
// single character. This makes cursor movement / submit reliable across agents.

export function splitKeys(seq: string): string[] {
  const keys: string[] = []
  let i = 0
  while (i < seq.length) {
    if (seq[i] === '\x1b') {
      let j = i + 1
      if (seq[j] === '[' || seq[j] === 'O') {
        j++
        while (j < seq.length && /[0-9;?]/.test(seq[j])) j++
        if (j < seq.length) j++ // final byte (the command letter / `~`)
      }
      keys.push(seq.slice(i, j))
      i = j
    } else {
      keys.push(seq[i])
      i++
    }
  }
  return keys
}

/**
 * Send `seq` key-by-key via `send`, ~`gapMs` apart so the agent sees individual keypresses.
 * First key fires immediately; the rest are scheduled. Single-key sequences are unchanged.
 */
export function sendKeysSeq(send: (k: string) => void, seq: string, gapMs = 24): void {
  const keys = splitKeys(seq)
  keys.forEach((k, idx) => {
    if (idx === 0) send(k)
    else setTimeout(() => send(k), idx * gapMs)
  })
}
